// extracted by mini-css-extract-plugin
module.exports = {"deleteSubProblemButtonContainer":"DeleteSubProblemButton_deleteSubProblemButtonContainer__GPNbU"};